<template>
  <el-dialog :title="$t('app.new')" :visible.sync="dialogVisible" width="400px">
    <el-input
      v-model="account"
      size="small"
      :placeholder="$t('app.account')"
      style="margin-bottom: 15px"
    >
    </el-input>
    <el-input size="small" v-model="username" :placeholder="$t('app.username')">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { addUser } from "@/api/systemManagement/userManagement";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      username: "",
      account: "",
    };
  },
  methods: {
    new() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.$confirm(this.$t("app.confirmAdd") + "?").then(() => {
        this.loading = true;
        addUser({ Account: this.account, Name: this.username })
          .then(() => {
            this.success();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.dialogVisible = false;
      this.$emit("handleAdd", {
        account: this.account,
        username: this.username,
        enable: true,
      });
    },
  },
};
</script>
